import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";
import { ChangeEvent, useCallback } from "react";

type InputImageWithPreviewProps = {
  imageData: string | null;
  onChange: (file: File | Blob | null) => void;
};

export const InputImageWithPreview = ({
  imageData,
  onChange,
}: InputImageWithPreviewProps) => {
  const theme = useTheme();
  const handleChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0] || null;
      onChange(file);
    },
    [onChange]
  );

  return (
    <div>
      <label css={fileInputStyle(theme)}>
        <input
          type="file"
          accept="image/*"
          onChange={handleChange}
          multiple={false}
        />
        {imageData == null ? "ファイルを選択する" : "変更・削除する"}
      </label>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      {imageData && (
        <img src={imageData} alt="" width={"100%"} height={"auto"} />
      )}
    </div>
  );
};

const fileInputStyle = (theme: Theme) => css`
  display: block;
  padding: 0.5rem;
  margin-bottom: 0.5rem;

  width: fit-content;
  border: 1px solid ${theme.palette.divider};
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  background-color: ${theme.palette.primary.main};
  color: ${theme.palette.primary.contrastText};
  font-size: 0.8rem;

  input {
    display: none;
  }
`;
